import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import TextField from 'components/TextField';
import Form from 'components/Form';
import LegacyEditor from 'components/LegacyEditor';

import { useErrorHandler } from 'lib';
import { PoiEditForm_poi$key } from '__generated__/PoiEditForm_poi.graphql';
import { PoiEditFormMutation } from '__generated__/PoiEditFormMutation.graphql';

type FormFields = {
  name: string;
  description: string;
};

type Props = {
  poi: PoiEditForm_poi$key;
};

const PoiEditForm: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, name, description } = useFragment(
    graphql`
      fragment PoiEditForm_poi on Poi {
        id
        name
        description
      }
    `,
    props.poi
  );

  const [update, updating] = useMutation<PoiEditFormMutation>(graphql`
    mutation PoiEditFormMutation($id: ID!, $input: UpdatePoiInput!) {
      updatePoi(id: $id, input: $input) {
        ...EntitySidebar_entity
        ...PoiEditForm_poi
      }
    }
  `);

  const initial = {
    name,
    description: description ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormFields) => {
      update({
        variables: { id, input },

        ...errorHandler({
          successMessage: 'Išsaugoti',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormFields> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="poiEditForm">
          <Section id="about" title="Apie">
            <Stack spacing={4}>
              <TextField fullWidth autoFocus name="name" label="Pavadinimas" />
              <LegacyEditor name="description" label="Aprašymas" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default PoiEditForm;
